<template>
    <div class="row">
        <div class="col-12" :class="'col-md-' + (!swapLabel ? left : right)" v-show="!hideLabel">
            <label>{{label}}</label>
            <span
                    v-if="!!helpText"
                    data-bs-placement="right"
                    data-container="body"
                    data-bs-toggle="popover"
                    :title="label"
                    :data-popover-content="helpText"
                    class="np-popover helpBtn addPopover helpHeader">
                <i tabindex="-1" class="fa fa-info-circle"></i>
            </span>
        </div>
        <div :class="'col-' + (hasHelp ? '10' : '12') + ' col-md-' + (hasHelp ? (right - 1) : right)">
            <div class="form-group" v-if="mode !== 'switch' && mode !== 'switch-horizontal'">
                <template v-for="(option, index) in options">
                    <div :class="['np-radio',mode, {'col-12': separateRows}]" role="radiogroup" :aria-label="label">
                        <input :id="id + '_option_' + index" :name="name" type="radio" :value="option.value"
                               class="form-control" :required="isRequired" :disabled="(!!disabled) || (!!option.disabled) || (!!isReadonly)" :readonly="isReadonly"
                               :checked="isCheckedOption(option)" @change="updateValue(option.value)"
                        />
                        <label  :class="['form-label side-label', {'big-label': bigLabel}]" :equal="isCheckedOption(option)" :for="id + '_option_' + index">{{option.label}}</label>
                        <span class="toggle-outside" v-if="mode === 'radio-switch'"><span class="toggle-inside"></span></span>
                    </div>
                </template>
            </div>
            <template v-else>
                <div class="form-group" :class="{'radio-switch radio-switch--vertical': (mode === 'switch'), 'switch-horizontal': (mode === 'switch-horizontal')}">
                    <template v-for="(option, index) in options">
                        <input :id="id + '_option_' + index" :name="name" type="radio" :value="option.value"
                               class="form-control" :required="isRequired" :disabled="(!!disabled) || (!!option.disabled) || (!!isReadonly)" :readonly="isReadonly"
                               :checked="isCheckedOption(option)" @change="updateValue(option.value)"
                        />
                        <label  :class="['form-label side-label', {'big-label': bigLabel}]"  :equal="isCheckedOption(option)" :for="id + '_option_' + index">{{option.label}}</label>
                    </template>
                    <span class="toggle-outside" v-if="(mode === 'switch')"><span class="toggle-inside"></span></span>
                </div>
            </template>
            <slot name="addendum"></slot>
        </div>
        <div v-if="hasHelp" class="col-2 col-md-1">
            <a data-popover-placement="bottom" :data-popover-title="help.split('||')[0]" :data-popover-content="help.split('||')[1]" href="#" class="helpBtn addPopover activePopover" data-original-title="" title=""><i tabindex="-1" class="flaticon-conversation6"></i></a>
        </div>
    </div>
</template>

<script>
    import NPInput from './np-input.vue';
    import NPResponsive from './np-responsive.vue';
    export default {
        name: 'np-radios',
        mixins: [NPInput, NPResponsive],
        props: {
            options: Array,
            asBlock: {
                type: Boolean,
                default: false
            },
            mode: {
                default: 'default'  //default, co-join, separate, switch, switch-horizontal, filter
            },
            swapLabel: {
                type: Boolean,
                default: false
            },
            hideLabel: {
                type: Boolean,
                default: false
            },
            id: {
                required: true
            },
            separateRows: {
                type: Boolean,
                default :false,
            },
            helpText: {
                type: String,
                default :'',
            },
            check_config: {
                default: true
            },
            default_config: {
                default: false
            },
            disabled: true,
            readonly: false,
            required: true,
            name: String,
            autoSelect: {
                default: true
            },
            bigLabel: {
                default: false
            },
            modelValue: [String, Number, Array, Object]
        },
        data () {
          return {
              page_config_required: false
          }
        },

        created: function () {
        },
        mounted: function () {
            // //console.log(this.id);
            if (!!this.autoSelect && !!this.options && this.options.length == 1) {
                this.updateValue(this.options[0].value)
            }
            if (['switch', 'switch-horizontal'].includes(this.mode) && this.options.length > 2) {
                console.error(`Radio '${this.label}' has more than two options and is using ${this.mode}. Please use another radio mode`);
            }
        },
        updated: function () {
            //automatically select the option if only has one option
            // //console.log(this.id);
            //don't select the same option twice
            if (!!this.autoSelect &&  !!this.options && this.options.length == 1 && this.value !== this.options[0].value) {
                this.updateValue(this.options[0].value)
            }
        },
        methods: {
            updateValue(value) {
                this.$emit('update:modelValue', value);
                this.$emit('input', value);
            },
            isCheckedOption(option){
                return option.value === this.modelValue;
            }
        },
        watch: {
            modelValue: function (newValue) {
                // let selector = $('[name="' + this.name + '"][value="' + newValue + '"]');
                // //console.log(selector)
                // selector.trigger('click')
            },
            //TODO if readonly is true disable the none checked fields.
            // "isReadonly": {
            //     immediate: true,
            //     handler: function (val, oldVal){
            //         if (!!val && val === true){
            //             console.log(this.id)
            //             $( '#'+this.id+':radio:not(:checked)').attr('disabled', true);
            //         }
            //     }
            // }
        },
        computed: {
            isReadonly: function () {
                // readonly attr on radio doesn't work. disabled is the right attr
                return this.check_config ? !!this.default_readonly : !!this.readonly;
            },
            isRequired: function () {
                // return true;
                return this.check_config ? !!this.page_config_required : !!this.required;
            },
            isChecked: function() {

            },
            hasHelp: function () {
                return !!this.help && this.help !== ''
            }
        }
    }
</script>
